import React, {useState} from 'react'
import Input from '../../Input/Input'
import PropTypes from 'prop-types'
import Prompt from '../Prompt'
import {Grommet, Layer} from 'grommet'

import styled from 'styled-components'

export const PromptType = {
  BUILDING: 'BUILDING',
  FLOOR: 'FLOOR',
  ROOM: 'ROOM',
  EQUIPMENT: 'EQUIPMENT',
  EMPLOYEE: 'EMPLOYEE',
  DEPARTMENT: 'DEPARTMENT'
}

const Select = ({
  type,
  onChange,
  title,
  placeholder,
  value,
  selectors,
  label,
  readOnly,
  parentContainer,
  parents,
  parentFields,
  clearValue,
  dataTestId,
  ariaLabel
}) => {
  const [displayPrompt, setDisplayPrompt] = useState(false)

  const onPromptSelect = evt => {	  
	    if(evt.key == "Enter" || evt.key == " " || !evt.key){ setDisplayPrompt(true) }
  }

  const onSelect = item => {
    setDisplayPrompt(false)
    onChange({item})
  }

  const handleClose = () => setDisplayPrompt(false)

  const clearPrompt = ({promptType}) => {
    setDisplayPrompt(false)
    let item = {
      promptType,
      isClear: true
    }
    onChange({item})
  }

  const onClearValue = ({promptType}) => {
    let item = {
      promptType,
      isClear: true
    }
    onChange({item})
  }

  const theme = {
    layer: {
      background: 'none'
    }
  }

  const getPrompt = () => {
    let parentRect = parentContainer.current.getBoundingClientRect()
    return (
      <Grommet theme={theme}>
        <Layer
          animation={false}
          modal
          onClickOutside={handleClose}
          onEsc={handleClose}
          background={'none'}
        >
          <Prompt
            onSelect={onSelect}
            parentRect={parentRect}
            type={type}
            title={title}
            placeholder={placeholder}
            handleClose={handleClose}
            onClearPrompt={clearPrompt}
            selectors={selectors}
            parents={parents}
            parentFields={parentFields}
          />
        </Layer>
      </Grommet>
    )
  }

  return (
    <div>
      <FieldTitleText>{label}</FieldTitleText>
      <InputContainer>
        <Input
          value={value.name}
          onClick={onPromptSelect}
          onKeyDown={onPromptSelect}
          readOnly={readOnly}
          clearValue={
            clearValue ? () => onClearValue({promptType: type}) : null
          }
          dataTestId={dataTestId || 'select-input'}
          ariaLabel={ariaLabel}
        />
      </InputContainer>

      {displayPrompt && getPrompt()}
    </div>
  )
}

Select.propTypes = {
  readOnly: PropTypes.bool.isRequired
}

Select.defaultProps = {
  readOnly: false,
  clearValue: false,
  parents: []
}

export default Select

const FieldTitleText = styled.label`
  font-size: 16px;
  color: #3e4044;
  font-weight: normal;
  padding: 8px 0px 4px 0px;
`

const InputContainer = styled.div`
  padding-top: 8;
  padding-bottom: 10;
  width: 334px;
  @media (max-width: 420px) {
    width: 100%;
  }
`
